import {Divider, Grid, TextField, Typography} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import {useState} from "react";
import IconButton from "@material-ui/core/IconButton";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import {validateEmail} from "../../../../../../../shared/utils/regexUtils";
import KeepPasswordDialog
    from "../../distribuzione-digitale-esim-dialog/confirmation-step/keep-passwords-dialog/KeepPasswordDialog";

const StepRiepilogoESim = (props) => {
    const [open, setOpen] = useState(true)
    const [passwordVisible, setPasswordVisible] = useState(false)

    const handleToggleVisibility = () => {
        setPasswordVisible((oldPasswordVisible) => !oldPasswordVisible)
    }

    const handleOnBlurEmailReferente = () => {
        props.setEmailReferenteError(!validateEmail(props.emailReferente))
    }

    return (
        <>
            <Box my="1em">
                <Typography variant="subtitle2" style={{textTransform: "uppercase", marginBlock: "1em"}}>
                    Ricordati di comunicare la password agli utenti finali
                </Typography>
                <Typography variant="body2">
                    Password necessaria all’apertura del file, <b>la password dovrà essere inviata all’utente finale
                    tramite il canale sicuro che preferisci</b>
                </Typography>
                <Grid container alignItems="center" style={{marginTop: "0.5em"}}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="overline">Password</Typography>
                    </Grid>
                    <Grid item xs={12} md={8} container alignItems="center">
                        <Typography variant="body2">
                            {passwordVisible ? props.password :
                                Array.from(Array(props.password.length).keys()).map(() => "*")}
                        </Typography>
                        <IconButton size="small" style={{marginLeft: "0.5em"}} onClick={handleToggleVisibility}>
                            {passwordVisible ? <VisibilityOff fontSize="small"/> : <Visibility fontSize="small"/>}
                        </IconButton>
                    </Grid>
                </Grid>
            </Box>
            <Divider style={{color: "rgba(0, 0, 0, 0.2)"}}/>
            <Box my="1em">
                <Typography variant="body2">
                    Indirizzo email che riceverà la notifica di avvenuto invio
                </Typography>
                <Grid container alignItems="center" style={{marginTop: "0.5em"}}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="overline">Indirizzo email referente</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField fullWidth
                                   value={props.emailReferente}
                                   onChange={(e) => props.setEmailReferente(e.target.value)}
                                   onBlur={handleOnBlurEmailReferente}
                                   helperText={props.emailReferenteError ?
                                       <Typography color="error" style={{fontSize: "12px"}}>
                                           L’indirizzo email non risulta valido
                                       </Typography> : null}/>
                    </Grid>
                </Grid>
            </Box>
            <Divider style={{color: "rgba(0, 0, 0, 0.2)"}}/>
            <KeepPasswordDialog handleDialogClose={() => setOpen(false)} open={open}/>
        </>
    )
}

export default StepRiepilogoESim;